import React from 'react'
import { Field } from 'redux-form'
import { LKTextArea } from 'loankeeper-common/components'
import { ComponentContainer } from '../../StyledComponents'

const normalize = (maxLength) => (value, prevValue) => (value.length > maxLength ? prevValue : value)

const TextAreaField = ({ input, height, small, noResize, required, meta: { error, touched }, ...rest }) => (
  <ComponentContainer className="lk-textarea__container" height={height} small={small} noResize={noResize}>
    <LKTextArea {...input} {...rest} error={error && touched} required={!touched && required} />
  </ComponentContainer>
)

const DecoratedField = (props) => <Field {...props} component={TextAreaField} normalize={normalize(props.maxLength)} />

export default DecoratedField
